import { useEffect } from 'react';
import { onAuthStateChanged, User as FirebaseUser } from 'firebase/auth';

import { auth } from '@lib/firebase';
import { useAuthStore } from '@lib/store/authStore';
import { getUserProfile } from '@lib/firebase/firestore';
import type { UserProfile } from '@shared/types/user';

/**
 * Hook to sync Firebase auth state with Zustand store
 * Should be called once at app root
 */
export function useAuthState(): void {
  const setUser = useAuthStore((state) => state.setUser);
  const setLoading = useAuthStore((state) => state.setLoading);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(
      auth,
      async (firebaseUser: FirebaseUser | null) => {
        if (firebaseUser) {
          try {
            // Get user profile from Firestore
            const profile: UserProfile = await getUserProfile(firebaseUser.uid);
            setUser(profile);
          } catch (error) {
            console.error('Error loading user profile:', error);
            // If profile doesn't exist, sign out
            setUser(null);
          }
        } else {
          setUser(null);
        }
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [setUser, setLoading]);
}

